module.exports = __webpack_public_path__ + "img/Differentiation-CRC_GSE206552.ff21e3f4.png";